import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogBoxDisplayModes, DialogBoxResults, IDialogBoxConfiguration, dialogBoxDefaults } from '../models/dialogDefaults';
import { DialogComponent } from '../components/dialog/dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private dialog: MatDialog,
    private snack: MatSnackBar) { }
    async showOk(title: string, message: string): Promise<DialogBoxResults>{
        return await this.showDialog(DialogBoxDisplayModes.Ok,
            title,
            message);
    }

    async showOkCancel(title:string, message: string): Promise<DialogBoxResults> {
        return await this.showDialog(DialogBoxDisplayModes.OkCancel,
            title,
            message);
    }

    async showYesNo(title:string, message: string): Promise<DialogBoxResults>{
        return await this.showDialog(DialogBoxDisplayModes.YesNo,
            title,
            message);
    }

    async showConfirmDelete():Promise<DialogBoxResults> {
        const title = "Delete Selected Item";
        const message = "Are you sure that you wish to delete the item that you have selected?  This action is unlikely to be reversable.";

        return await this.showYesNo(title, message);
    }

    async showSuccess(message: string){
        this.snack.open(message, "X",{
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            duration: 5000,
            
        });
    }

    async showPleaseWait(message: string): Promise<MatDialogRef<DialogComponent>>{
        const data: IDialogBoxConfiguration = {
            mode: DialogBoxDisplayModes.PleaseWait,
            title: 'Please wait',
            message: message
        };

        const dialog = this.dialog.open(DialogComponent,
            {
                data,
                ...dialogBoxDefaults
            }
        );

        await dialog.afterOpened().toPromise();
        return dialog;
    }

    async createLog(message: string, errorMessage: string, ...params: any){
        const now = moment().format("yyyyMMDD HH:mm:ss:");
        console.log(`${now} ${message} ${errorMessage}`, params);
    }

    async reportError(level: ErrorLevels, message: string, errorMessage: string, ...params: any){
        this.createLog(message, params);

        if(level === ErrorLevels.LogOnly){
            //Nothing - log already done
        }else if(level === ErrorLevels.Warning){
            //Snackbar the error
            // this.snack.open(message, "X",{
            //     horizontalPosition: 'center',
            //     verticalPosition: 'top',
            //     duration: 5000
            // });
        }else if(level === ErrorLevels.Critical){
            //Dialog box the error
            const fullMessage = `${message}:<br/><br/><em>${errorMessage}</em>`;
            await this.showDialog(DialogBoxDisplayModes.Ok,
                "An error has occurred",
                fullMessage);
        }
    }
    

    private async showDialog(mode: DialogBoxDisplayModes,
        title: string,
        message: string)
    {
        const data: IDialogBoxConfiguration = {
            mode: mode,
            title: title,
            message: message
        };
        
        const result = await this.dialog.open(DialogComponent,
            {
                data,
                ...dialogBoxDefaults
            }).afterClosed()
            .toPromise();
        
        if(result){
            return result;
        }else{
            return DialogBoxResults.Undefined;
        }
    }
}

export enum ErrorLevels {
    LogOnly,
    Warning,
    Critical
}

